import React, { useState, useEffect, useLayoutEffect, useRef } from 'react';
import { updateRetrospective } from '../../services/retrospectives';
import Timer from './Timer';
import * as Styled from './style';
import { logEvent, TrackingEvents } from '../../tracking';

const ELLIPSIS = [1, 2, 3, 4];

function TimerContainer({
  readOnly,
  timerInitialTime = 0,
  timerStartedAt = 0,
  timerIsTimerActive = false,
  retrospectiveId,
}) {
  const [currentTime, setCurrentTime] = useState(timerInitialTime);
  const [startedAt, setStartedAt] = useState(timerStartedAt);
  const [isPainelActive, setIsPainelActive] = useState(false);
  const [isTimerActive, setIsTimerActive] = useState(timerIsTimerActive);
  const [renderTimer, setRenderTimer] = useState(false);

  const timerButtonReference = useRef();
  const timerPainelReference = useRef();

  const startTimer = () => {
    if (currentTime <= 0) return;
    logEvent(TrackingEvents.START_TIMER, { currentTime });
    const newStartedAt = Date.now();
    setIsTimerActive(true);
    setStartedAt(newStartedAt);

    if (!readOnly) {
      updateRetrospective(retrospectiveId, {
        timerIsTimerActive: true,
        timerStartedAt: newStartedAt,
      });
    }
  };

  const stopTimer = (resetTime = false) => {
    setIsTimerActive(false);
    setStartedAt(0);

    if (!readOnly) {
      logEvent(
        resetTime ? TrackingEvents.STOP_TIMER : TrackingEvents.PAUSE_TIMER
      );
      updateRetrospective(retrospectiveId, {
        timerStartedAt: 0,
        timerIsTimerActive: false,
        timerInitialTime: resetTime ? 0 : currentTime,
      });
    }
  };

  const resetTimer = () => {
    setCurrentTime(0);
    stopTimer(true);
  };

  const setTimer = (time) => {
    if (time === undefined) return;
    const timerUpdateParameters = { timerInitialTime: time };
    if (isTimerActive) {
      const newStartedAt = Date.now();
      setStartedAt(newStartedAt);
      timerUpdateParameters.timerStartedAt = newStartedAt;
    }
    if (!readOnly)
      updateRetrospective(retrospectiveId, { ...timerUpdateParameters });
    setCurrentTime(time);
  };

  const togglePainel = () => {
    if (!readOnly) {
      setIsPainelActive(!isPainelActive);
    }
  };

  useEffect(() => {
    setCurrentTime(timerInitialTime);
    setIsTimerActive(timerIsTimerActive);
    setStartedAt(timerStartedAt);
  }, [timerStartedAt, timerInitialTime, timerIsTimerActive]);

  useLayoutEffect(() => {
    if (!isTimerActive) {
      setRenderTimer(true);
      return;
    }
    const interval = setInterval(() => {
      const timeDifference = Date.now() - startedAt;
      const newTimer = currentTime - timeDifference;
      if (newTimer <= 0) {
        clearInterval(interval);
        resetTimer();
      } else setCurrentTime(newTimer);
      if (!renderTimer) setRenderTimer(true);
    }, 1000);

    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTimerActive, startedAt]);

  return renderTimer ? (
    <Timer
      currentTime={currentTime}
      setTimer={setTimer}
      startTimer={startTimer}
      stopTimer={stopTimer}
      resetTimer={resetTimer}
      togglePainel={togglePainel}
      readOnly={readOnly}
      timerButtonRef={timerButtonReference}
      timerPainelRef={timerPainelReference}
      isPainelActive={isPainelActive}
      isTimerActive={isTimerActive}
    />
  ) : (
    <Styled.ElipsisLoading readOnly={readOnly}>
      {ELLIPSIS.map((element) => (
        <div key={element} />
      ))}
    </Styled.ElipsisLoading>
  );
}

export default TimerContainer;
